import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import HistoryListing from '#client/components/HistoryListing';
import Skeleton from '#client/components/Skeleton';
import { generateEntitlements } from '#client/utils/entitlements';
import { buildCartUrl } from '#client/utils/urls';

import AmendmentBanner from './AmendmentBanner';

import useStyles from './useStyles';

const Amendments = ({
  loading,
  data: {
    businessEntity: {
      businessEntityUuid,
      businessEntityType
    } = {},
    accountInfo: {
      pricing = []
    } = {},
    orderTasksLegacy: {
      orderTasksLegacy = []
    } = {}
  } = {}
}) => {
  const classes = useStyles();
  const entitlements = generateEntitlements(orderTasksLegacy);
  const formationEntitlement = entitlements.get(`${businessEntityType}_formation`);
  const formationFulfillment = formationEntitlement?.fulfillment;
  const isFormationCompleted = formationFulfillment?.isActive;

  const amendmentPricingObj = pricing.find(({ service }) => service === `${businessEntityType}_amendment`);
  const amendmentPricing = amendmentPricingObj?.amount;

  const amendments = orderTasksLegacy.filter(({ orderTaskType }) => orderTaskType.includes('amendment'));

  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.profileHead}
      >
        <Title level={1} variant="lg-alt" gutterBottom>Amendments</Title>
      </Grid>
      {loading ? (
        <Paper className={classes.amendment}>
          <Grid container direction="row" alignItems="center" justifyContent="space-between">
            <Grid item xs={12} sm={8} container>
              <Skeleton height="80px" />
            </Grid>
            <Grid item xs={12} sm={2} container>
              <Skeleton style={{ marginTop: '10px' }} />
            </Grid>
          </Grid>
        </Paper>
      ) : isFormationCompleted && (
        <AmendmentBanner
          amendmentUrl={buildCartUrl(`${businessEntityType}_amendment`, { businessEntityUuid })}
          amendmentPricing={amendmentPricing}
        />
      )}
      <HistoryListing ifEmptyName="Amendments" list={amendments} loading={loading} />
    </div>
  );
};

Amendments.propTypes = {
  data: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool
};

export default Amendments;
